import documentos from '@/core/store/pedido/documento'

export default {
	modules: {
		documentos
	}
}
